
import { Directive, HostListener, ElementRef, OnInit } from "@angular/core";
import { TeleLadaPipe } from './telefono.pipe';

@Directive({ selector: "[telefonoLada]" })
export class TeleLadaDirective implements OnInit {

  private el: HTMLInputElement;

  constructor(
    private elementRef: ElementRef,
    private teleLadaPipe: TeleLadaPipe
  ) {
    this.el = this.elementRef.nativeElement;
  }

  ngOnInit() {
    this.el.value =  this.teleLadaPipe.transform(this.el.value);
  }

  @HostListener("change", ["$event.target.value"])
  onChange(value) {
    this.el.value = this.teleLadaPipe.transform(value); // opossite of transform
  }
  @HostListener("focus", ["$event.target.value"])
  onFocus(value) {
    this.el.value = this.teleLadaPipe.transform(value); // opossite of transform
  }

  @HostListener("blur", ["$event.target.value"])
  onBlur(value) {
    this.el.value = this.teleLadaPipe.transform(value);
  }

}



// WEBPACK FOOTER //
// ./src/app/form/core/directive/telefono.directive.ts